

export const defautMailTemplate = `<p>
   <img src="/assets/email-logo.png"/></p><p><br></p>
   <h1>Hello <span style="color: rgb(178, 178, 0);">{evaluator}</span></h1>
   <p><br></p><h3>
     You are invited to give feedback for {participant} 
     in 360 degree feedback exercise and provide your input.
      It is essential that you provide your feedback before</h3>
      <p><strong>{date}.</strong></p><p><br></p>
      <h3>please click on the provided feedback button below to get started.</h3>
      <p><br></p><p><br></p><p class="ql-align-center">
      <a href="www.google.com" rel="noopener noreferrer"
       target="_blank" style="background: rgba(102, 129, 2, 0.7); color: rgb(255, 255, 255); 
       padding: 12px 36px; border-radius: 10px; text-decoration: none;"> Provide Feedback</a>
       </p><h3><br></h3><h3>For any enquiries please feel free to contact us.</h3><p><br>
       </p><h3>Warm Regards,</h3><p>Zainab Ahmed</p><p>Customer Service Team</p>
        <p><br></p><p class="ql-align-center"><br></p>
       <p class="ql-align-center" style="background: rgb(230, 230, 233);
        padding: 20px 10px; margin-top: 5px;">For&nbsp;<span style="color: rgb(178, 178, 0);">
        Support </span>&nbsp;Contact:  360@testassessify.com</p></div>
    `;

    